import { render, staticRenderFns } from "./WarningPage.vue?vue&type=template&id=ac7b7856&"
import script from "./WarningPage.vue?vue&type=script&lang=js&"
export * from "./WarningPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports